import produce from 'immer';
import { ActionType, getType } from 'typesafe-actions';

import { getProductReviewDetailActions } from '../../redux/actions/getProductReviewDetailActions';
import { getProductReviewListDataActions } from '../../redux/actions/getProductReviewListDataActions';
import type { ListLoadingTypes } from '../../types/Common';
import type { ProductReviewDetail } from '../../types/ProductReviewDetailResponse';
import type { ProductReview } from '../../types/ProductReviewListDataResponse';
import * as arrayHandler from '../../utils/arrayHandler';

interface State {
  isDetailFetching: boolean;
  isDetailError: boolean;
  detailLoadingType: ListLoadingTypes;
  detailData: ProductReviewDetail | null;
  isListFetching: boolean;
  listLoadingType: ListLoadingTypes;
  listData: ProductReview[];
  currentPage: number;
  hasMoreItems: boolean;
}

export const defaultState: State = {
  isDetailFetching: true,
  isDetailError: false,
  detailLoadingType: 'new',
  detailData: null,
  isListFetching: true,
  listLoadingType: 'new',
  listData: [],
  currentPage: 1,
  hasMoreItems: true,
};

export default produce(
  (
    draft: State,
    action: ActionType<
      | typeof getProductReviewDetailActions
      | typeof getProductReviewListDataActions
    >
  ) => {
    switch (action.type) {
      case getType(getProductReviewDetailActions.request): {
        const { loadingType } = action.payload;

        draft.isDetailFetching = true;
        draft.isDetailError = false;
        draft.detailLoadingType = loadingType;
        break;
      }
      case getType(getProductReviewDetailActions.success): {
        const { data } = action.payload;

        draft.detailData = data.product;
        draft.isDetailFetching = false;
        break;
      }
      case getType(getProductReviewDetailActions.failure): {
        draft.isDetailFetching = false;
        draft.isDetailError = true;
        break;
      }
      case getType(getProductReviewListDataActions.request): {
        const { loadingType, page } = action.payload;

        draft.isListFetching = true;
        draft.listLoadingType = loadingType;
        draft.currentPage = page;
        break;
      }
      case getType(getProductReviewListDataActions.success): {
        const { data } = action.payload;
        const newItems =
          draft.listLoadingType === 'loadMore'
            ? draft.listData.concat(data.product_skus)
            : data.product_skus;

        draft.hasMoreItems = data.has_next_page;
        draft.isListFetching = false;
        draft.listData = arrayHandler.uniqueArray(newItems, x => [x.id, x]);
        break;
      }
      case getType(getProductReviewListDataActions.failure): {
        draft.isListFetching = false;
        break;
      }
      default: {
        break;
      }
    }
  },
  defaultState
);
